// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  font-family: 'Poppins', sans-serif;
  /* font-family: 'Inter', sans-serif; */
  font-size: 14px;
  text-shadow: none;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kCAAkC;EAClC,sCAAsC;EACtC,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["*{\n  margin: 0;\n  font-family: 'Poppins', sans-serif;\n  /* font-family: 'Inter', sans-serif; */\n  font-size: 14px;\n  text-shadow: none;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
